import styled from "styled-components";

export const RattingWrapper = styled.div`
    .box_is_rated{
        height: 40px;
    }
    .btn_star{
        background-color: white;
    }
    .btn_filter{
        height: 30px;
        outline: none;
    }
`
